var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement } from "lit/decorators.js";
import { LitElement } from "lit";
import { eventManager } from "../../decorators/event.js";
import { matchBreakpoint } from "../../utils/media.js";
import { debounce } from "../../utils/js.js";
import { setStaticAttributePropertiesOnTree } from "../../utils/morph/helpers.js";
import hydratedClass from "../../decorators/hydrated_class.js";
/**
 * Render different content depending on [Ionic breakpoints](https://ionicframework.com/docs/layout/grid#default-breakpoints).
 */
let AdaptiveRender = class AdaptiveRender extends LitElement {
    constructor() {
        super(...arguments);
        this.handleResize = () => {
            this.requestUpdate();
        };
    }
    connectedCallback() {
        super.connectedCallback();
        this.ev.on(window, "resize", debounce(this.handleResize, 100));
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        this.ev.removeListeners();
    }
    createRenderRoot() {
        return this;
    }
    get templates() {
        return Array.from(this.querySelectorAll(":scope > template[at]"));
    }
    get templatesForBreakpoint() {
        return this.templates?.filter((template) => matchBreakpoint(template.getAttribute("at")));
    }
    get templateElements() {
        return this.templatesForBreakpoint?.map((template) => {
            return Array.from(template.content.cloneNode(true).children).map((el) => {
                setStaticAttributePropertiesOnTree(el);
                return el;
            });
        });
    }
    render() {
        return this.templateElements;
    }
};
__decorate([
    eventManager()
], AdaptiveRender.prototype, "ev", void 0);
AdaptiveRender = __decorate([
    hydratedClass(),
    customElement("adaptive-render")
], AdaptiveRender);
export { AdaptiveRender };
//# sourceMappingURL=adaptive-render.js.map